/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {MemoryStoreAdapter} from '@webex/webex-core';

export default {
  boundedAdapter: MemoryStoreAdapter,
  unboundedAdapter: MemoryStoreAdapter,
};
